// import { TypographyOptions } from '@mui/material/styles/createTypography';

import { TypographyOptions } from '@mui/material/styles/createTypography';

const typography: TypographyOptions = {
  fontFamily: ['Open Sans', 'Helvetica Neue', 'Arial', 'sans-serif'].join(','),
  h1: {
    fontFamily: 'Inter',
    fontSize: 34,
    fontWeight: 700,
    lineHeight: 1.25,
  },
  h2: {
    fontFamily: 'Inter',
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.25,
  },
  h3: {
    fontFamily: 'Inter',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.25,
  },
  h4: {
    fontFamily: 'Inter',
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 1.35,
  },
  h5: {
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.35,
  },
  h6: {
    fontFamily: 'Inter',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.35,
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.35,
    fontSize: 18,
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 1.35,
    fontSize: 16,
  },
  subtitle3: {
    fontWeight: 600,
    lineHeight: 1.35,
    fontSize: 14,
  },
  body1: {
    fontSize: 18,
    fontWeight: 400,
    lineHeight: 1.4,
  },
  body2: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.4,
  },
  body3: {
    lineHeight: 1.5,
    fontSize: 14,
    fontWeight: 400,
  },
  caption: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.35,
  },
  button: {
    fontFamily: 'Open Sans',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1,
    textTransform: 'none',
  },
  button_lg: {
    fontFamily: 'Open Sans',
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1,
    textTransform: 'none',
  },
  button_sm: {
    fontFamily: 'Open Sans',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.4,
    textTransform: 'none',
  },
  overline: {
    fontSize: 10,
    fontWeight: 400,
    lineHeight: 1.35,
  },
};

export default typography;
